/* unplugin-vue-components disabled */import script from "./addProjectItem.vue?vue&type=script&setup=true&lang=js"
export * from "./addProjectItem.vue?vue&type=script&setup=true&lang=js"

import "./addProjectItem.vue?vue&type=style&index=0&id=3ae8e2c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ae8e2c0"]])

export default __exports__